import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { keys as getIDBKeyValKeys, del as delIDBKeyVal } from 'idb-keyval'
import { useStytchB2BClient } from '@stytch/react/b2b'
import { useQueryClient } from '@tanstack/react-query'
import { IDB_VALID_KEY_PREFIX } from '@/utils/persister'

export default function useSignOut() {
  const queryClient = useQueryClient()
  const stytch = useStytchB2BClient()
  const navigate = useNavigate()

  const signOut = useCallback(async () => {
    // Clear the query cache
    queryClient.clear()
    // Delete each relevant TanStack Query entry from IndexedDB
    const allKeys = await getIDBKeyValKeys()
    const tanstackQueryKeys = allKeys.filter(
      (key) => typeof key === 'string' && key.startsWith(IDB_VALID_KEY_PREFIX),
    )
    await Promise.all(tanstackQueryKeys.map((key) => delIDBKeyVal(key)))
    await stytch.session.revoke()
    navigate('/')
  }, [navigate, queryClient, stytch.session])

  return signOut
}
